import { Container } from "@components/wrapper"
import clsx from "clsx"
import React, { useState } from "react"
import { FaChevronDown } from "react-icons/fa"
import { IoMdClose } from "react-icons/io"
import { IoCheckmark } from "react-icons/io5"
import { BootcampHeading } from "../general/ProgramHeading"

interface Comparison {
  comparison_label: string
  comparison_sub_level?: string
  based_bootcamp: ComparisonProp
  other_bootcamp: ComparisonProp
}

interface ComparisonProp {
  comparison_type: "text" | "yes" | "no"
  comparison_text: string
  comparison_subtitle: string
}

const COMPARISONS: Comparison[] = [
  {
    comparison_label: "Durasi",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Flexible",
      comparison_subtitle: "*Tergantung seberapa cepat kamu menyelesaikan misi",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Sesuai Jadwal & Lama",
      comparison_subtitle: "3-9 Bulan",
    },
  },
  {
    comparison_label: "Sistem Belajar",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Berbasis Misi",
      comparison_subtitle: "Seperti game petualangan",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Webinar Series",
      comparison_subtitle: "Semangat diawal saja",
    },
  },
  {
    comparison_label: "Materi Belajar",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Lebih Lengkap",
      comparison_subtitle: "Live session, video, modul e-book, artikel & 1on1 Mentoring",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Live session + PPT",
      comparison_subtitle: "",
    },
  },
  {
    comparison_label: "Waktu Untuk Lulus",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Bisa Lebih Cepat",
      comparison_subtitle: "1-3 Bulan",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Lebih Lama",
      comparison_subtitle: "3 - 9 Bulan",
    },
  },
  {
    comparison_label: "Proses Mencari & Mendapatkan Kerja",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "0 - 2 Bulan",
      comparison_subtitle: "70% Alumni Bekerja Sebelum Lulus",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Menunggu Program Selesai",
      comparison_subtitle: "6 Bulan + Berbulan bulan",
    },
  },
  {
    comparison_label: "Career Specialization",
    comparison_sub_level: "(Belajar sesuai minat karir)",
    based_bootcamp: {
      comparison_type: "yes",
      comparison_text: "",
      comparison_subtitle: "",
    },
    other_bootcamp: {
      comparison_type: "no",
      comparison_text: "",
      comparison_subtitle: "",
    },
  },
  {
    comparison_label: "Real Project/Apprenticeship",
    based_bootcamp: {
      comparison_type: "yes",
      comparison_text: "",
      comparison_subtitle: "",
    },
    other_bootcamp: {
      comparison_type: "yes",
      comparison_text: "",
      comparison_subtitle: "Tapi 3-10x Lebih Mahal",
    },
  },
  {
    comparison_label: "Personalized Career Services",
    based_bootcamp: {
      comparison_type: "yes",
      comparison_text: "",
      comparison_subtitle: "",
    },
    other_bootcamp: {
      comparison_type: "no",
      comparison_text: "Not All",
      comparison_subtitle: "",
    },
  },
  {
    comparison_label: "Refund Guarantee",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Up to 110 %",
      comparison_subtitle: "Highest in the Industry",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Up to 100 %",
      comparison_subtitle: "",
    },
  },
  {
    comparison_label: "Persentase % Refund",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Ditentukan di akhir ",
      comparison_subtitle: "Berdasarkan IPK hasil belajar",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Ditentukan diawal",
      comparison_subtitle: "Ketika belum belajar apa-apa",
    },
  },
  {
    comparison_label: "Test Masuk",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Tidak Ada",
      comparison_subtitle: "",
    },
    other_bootcamp: {
      comparison_type: "no",
      comparison_text: "Ada Test",
      comparison_subtitle: "",
    },
  },
  {
    comparison_label: "Return on Investment",
    based_bootcamp: {
      comparison_type: "text",
      comparison_text: "Lebih Cepat",
      comparison_subtitle: "Cukup gajian 1 bulan, investasimu sudah bisa kembali 2x - 5x",
    },
    other_bootcamp: {
      comparison_type: "text",
      comparison_text: "Lebih Lama",
      comparison_subtitle: "3 - 12 Bulan Gajian baru balik modal 1x",
    },
  },
]

export const BootcampComparison = () => {
  const [isOpened, setIsOpened] = useState(false)
  const [shownData, setShownData] = useState<Comparison[]>([COMPARISONS[0]])

  function handleShown() {
    if (isOpened) {
      setShownData([COMPARISONS[0]])
      setIsOpened(false)
    } else {
      setShownData(COMPARISONS)
      setIsOpened(true)
    }
  }

  return (
    <Container className="sm:py-20 py-9">
      <div className="sm:mb-9 mb-6 relative">
        <BootcampHeading
          id="comparisons"
          title="PERBANDINGAN"
          subTitle="Mengapa Bootcamp Harisenin.com?"
        />
      </div>

      {/* Web */}
      <table className="table-comparison sm-only:hidden">
        <thead className="font-urbanist">
          <tr>
            <th className="w-1/3"></th>
            <th className="w-1/3">
              <div className="text-center mx-auto">Harisenin Mission Based Bootcamp</div>
            </th>
            <th className="w-1/3">Other Bootcamp</th>
          </tr>
        </thead>
        <tbody>
          {COMPARISONS.map((com, idx) => (
            <tr key={idx}>
              <td className="text-primary-black">
                <div className="font-urbanist sm:text-xl font-bold">{com.comparison_label}</div>
                {com.comparison_sub_level && <div>{com.comparison_sub_level}</div>}
              </td>
              <td>
                {com.based_bootcamp.comparison_type === "text" && (
                  <div className="sm:text-lg text-primary-black font-semibold">
                    {com.based_bootcamp.comparison_text}
                  </div>
                )}
                {com.based_bootcamp.comparison_type === "yes" && (
                  <div className="sm:text-2xl text-new-blue">
                    <IoCheckmark />
                  </div>
                )}
                {com.based_bootcamp.comparison_subtitle && (
                  <div className="text-primary-black">{com.based_bootcamp.comparison_subtitle}</div>
                )}
              </td>
              <td>
                {com.other_bootcamp.comparison_type === "text" && (
                  <div className="sm:text-lg text-primary-black font-semibold">
                    {com.other_bootcamp.comparison_text}
                  </div>
                )}
                {com.other_bootcamp.comparison_type === "yes" && (
                  <div className="sm:text-2xl text-new-blue">
                    <IoCheckmark />
                  </div>
                )}
                {com.other_bootcamp.comparison_type === "no" && (
                  <div className="text-[#EF2547]">
                    {com.other_bootcamp.comparison_text ? (
                      <span className="sm:text-lg font-semibold">
                        {com.other_bootcamp.comparison_text}
                      </span>
                    ) : (
                      <IoMdClose className="sm:text-2xl" />
                    )}
                  </div>
                )}
                {com.other_bootcamp.comparison_subtitle && (
                  <div className="text-primary-black">{com.other_bootcamp.comparison_subtitle}</div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile */}
      <div className="sm:hidden grid gap-4 relative">
        <button
          className="text-new-blue gap-1 flex items-center w-full justify-between"
          onClick={handleShown}
        >
          <span>Lihat Perbandingan</span>{" "}
          <FaChevronDown className={clsx(isOpened && "rotate-180 transform")} />
        </button>

        <div className="grid gap-4">
          {shownData.map((data, idx) => (
            <div key={idx}>
              <table className="table-comparison-mobile">
                <thead>
                  <tr>
                    <th className="" colSpan={2}>
                      <span>{data.comparison_label}</span> <br />
                      {data.comparison_sub_level && <span className="font-normal text-sm">{data.comparison_sub_level}</span>}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="font-bold">Harisenin.com</td>
                    <td className="text-sm">Bootcamp Lain</td>
                  </tr>
                  <tr>
                    <td>
                      {data.based_bootcamp.comparison_type === "text" && (
                        <div className="text-sm text-primary-black font-semibold">
                          {data.based_bootcamp.comparison_text}
                        </div>
                      )}
                      {data.based_bootcamp.comparison_type === "yes" && (
                        <div className="sm:text-2xl text-new-blue">
                          <IoCheckmark />
                        </div>
                      )}
                      {data.based_bootcamp.comparison_subtitle && (
                        <div className="text-primary-black text-xs">
                          {data.based_bootcamp.comparison_subtitle}
                        </div>
                      )}
                    </td>
                    <td>
                      {data.other_bootcamp.comparison_type === "text" && (
                        <div className="text-sm text-primary-black font-semibold">
                          {data.other_bootcamp.comparison_text}
                        </div>
                      )}
                      {data.other_bootcamp.comparison_type === "yes" && (
                        <div className="sm:text-2xl text-new-blue">
                          <IoCheckmark />
                        </div>
                      )}
                      {data.other_bootcamp.comparison_type === "no" && (
                        <div className="text-[#EF2547]">
                          {data.other_bootcamp.comparison_text ? (
                            <span className="text-sm font-semibold">
                              {data.other_bootcamp.comparison_text}
                            </span>
                          ) : (
                            <IoMdClose className="sm:text-2xl" />
                          )}
                        </div>
                      )}
                      {data.other_bootcamp.comparison_subtitle && (
                        <div className="text-primary-black text-xs">
                          {data.other_bootcamp.comparison_subtitle}
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
        </div>

        {!isOpened && (
          <div className={clsx("blur-mobile w-full absolute ", "h-[95px] -bottom-15")} />
        )}
      </div>
    </Container>
  )
}
